<template id="cmsForm">    
    <div>                
        <div class="row">
            <div class="col-md-10">
                <h3>Menu (<span v-if="item_id">แก้ไข</span><span v-if="!item_id">เพิ่มใหม่</span>)</h3>
            </div>
        </div>
        
        <div class="row">                
            <div class="col-md-3">
                <div class="form-group">
                    <label for="post_tag_language_id">ภาษา</label>
                    <select class="form-control" id="post_tag_language_id" v-model="form.language">
                        <option></option>
                        <option v-for="language in languages" v-bind:key="language.id" :value="language.code">{{language.name}}, {{language.localize}}</option>
                    </select>
                    <form-error :isError="validateError.language.error" :errorMessage="validateError.language.message"></form-error>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label for="post_tag_name">ชื่อเมนู</label>
                    <input type="text" class="form-control" id="post_tag_name" v-model="form.name">                        
                    <form-error :isError="validateError.name.error" :errorMessage="validateError.name.message"></form-error>
                </div>
            </div>
            
            <div class="col-md-3">
                <div class="form-group">
                    <label for="post_status">ปิดการใช้งาน</label>
                    <select class="form-control" id="post_status" v-model="form.disabled">
                        <option :value=0>ไม่</option>
                        <option :value=1>ใช่</option>
                    </select>
                </div>
            </div>
        </div>
        
        <div class="row mb-2">                
            <!-- <div class="col-md-1">
                <h5>Menu Items</h5>
            </div> -->
            <div class="col-md-11">
                <div class="input-group">                        
                    <span class="input-group-text handle">เมนูย่อยใหม่</span>
                    <input type="text" class="form-control" placeholder="Label" v-model="new_item.label">
                    <input type="text" class="form-control" placeholder="url" v-model="new_item.url">
                    <select id="" class="form-control" v-model="new_item.category_id">
                        <option value="-1">ประเภท</option>
                        <option v-for="category in categories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                    </select>
                    <select id="" class="form-control" v-model="new_item.disabled">
                        <option value="-1">สถานะ</option>
                        <option value="0">เปิดการใช้งาน</option>
                        <option value="1">ปิดการใช้งาน</option>
                    </select>                    
                </div>                    
            </div>
            <div class="col-md-1">
                <button class="btn btn-primary form-control" @click="addNewItemToMenuItems">เพิ่ม</button>
            </div>
        </div>
        <div class="row mt-10">
            <div class="col-md-12">                
                <nested-dragable :list="menu_items" :categories="categories" />                
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">            
                <span class="text text-danger" v-bind:class="{'d-block':menu_item_data_entry_error,'d-none':!menu_item_data_entry_error}">ไม่สามารถบันทึกได้ มีปัญหาการกรอกข้อมูลในรายการเมนูย่อยกรุณาตรวจสอบ </span>            
            </div>
            <div class="col-md-6">
                <div class="form-group float-right">
                    <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;" class="btn btn-secondary">ยกเลิก</a>
                    <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">บันทึก</button>
                    <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">บันทึก และ บันทึกเพิ่ม</button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import nestedDragable from "./dragable/nestedWithUL.vue";
    export default {        
        components: {
            nestedDragable,
        },        
        props:{
            //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
            //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
            item_id:'', 
            user_id:0,
        },
        data() {                        
            let item_validateError = {                
                label:{error:false,message:''},
                url:{error:false,message:''},
                disabled:{error:false,message:''},
                category_id:{error:false,message:''},
            }
            return {          
                item_validateError:item_validateError,
                menu_item_data_entry_error:false,
                new_item:{
                    label:'',
                    url:'',
                    disabled:-1,
                    category_id:-1,
                    children:[],
                },
                initial_menu_items:[
                    {                    
                    "label": "หน้าแรก",
                    "url": "/",
                    "disabled": 0,
                    "children_in_post_category": 0,
                    "children_post_category_id": null,
                    "is_panel": 0,
                    "panel_row": null,
                    "panel_column": null,                   
                    "category_id":1,
                    "validateError":this.vl_props(),
                    "children":[],                                        
                },
                {
                    "label": "หน้าที่สอง",
                    "url": "/",
                    "disabled": 0,
                    "children_in_post_category": 0,
                    "children_post_category_id": null,
                    "is_panel": 0,
                    "panel_row": null,
                    "panel_column": null,
                    "category_id":1,
                    "validateError":this.vl_props(),
                    "children": [
                        {                     
                            "label": "หน้าที่สอง อันดับแรก",
                            "url": "/หน้าที่สอง/หนึ่ง/",
                            "disabled": 0,
                            "children_in_post_category": 1,
                            "children_post_category_id": 1,
                            "is_panel": 0,
                            "panel_row": null,
                            "panel_column": null,
                            "category_id": 10,
                            "validateError":this.vl_props(),
                            "children":[],
                        }
                    ]                    
                }],
                menu_items: [],
                form:{ 
                    //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
                    name:'',
                    language:'',
                    disabled:0,
                    menu_items:this.menu_items,
                },                
                validateError:{ 
                    // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
                    name:{error:false,message:''},
                    language:{error:false,message:''},
                    menu_items:[],
                },
                languages:{ 
                    // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel                                    
                },
                categories:{
                    //category ของ menu_items
                },
                base_url:'/menu', // base url (เปลี่ยน)                   
            }
        },    
            
        mounted() {},
        beforeMount(){},
        created(){                        
            this.fetchLanguages();
            this.fetchCategories();
            if(this.item_id){ //ถ้าเป็นการแก้ไข ให้ไปดึงข้อมูลเดิมมาใส่ฟอร์มด้วยฟังก์ชั่น load(this.item_id)
                this.load(this.item_id);
            }else{
                this.menu_items = this.initial_menu_items;
            }
        },
        methods:{
            vl_props(){
                return {                
                label:{error:false,message:''},
                url:{error:false,message:''},
                disabled:{error:false,message:''},
                category_id:{error:false,message:''},
                }
            },
            create_new_items(){
                return {
                    label:this.new_item.label,
                    url:this.new_item.url,
                    disabled:this.new_item.disabled,
                    category_id:this.new_item.category_id,
                    children:[],
                    validateError:this.vl_props(),
                }
            },
            load(id){
                axios.get(this.base_url+'/'+id).then(response => {
                    // console.log(response.data);
                    //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
                    this.form.name = response.data.menu[0].name;
                    this.form.language = response.data.menu[0].language.code;
                    this.form.disabled = response.data.menu[0].disabled;
                    this.menu_items = response.data.menu[0].menu_items;
                })
                .catch(errors => {
                    // console.log(errors);
                    alert('ไม่สามารถดึง record id='+id+' ได้');
                })
                ;
            },
            addNewItemToMenuItems(){
                // console.log(this.item_validateError.label.message);
                // alert(this.item_validateError.label.message);
                let new_items = this.create_new_items()
                this.menu_items.push(new_items);
            },
            saveWithGoBack(){
                this.save('');
            },            
            saveWithMore(){
                this.save('more');                
            },
            save(whatNext){
                let save_url = '';
                this.menu_item_data_entry_error = false;
                if(this.item_id!=''){
                    save_url = this.base_url+'/'+this.item_id+'/update';
                }else{
                    save_url = this.base_url;
                }
                let me = this; 
                // console.log(this.menu_items);
                this.form.menu_items = this.menu_items;
                this.validateError.name.error = false;
                this.validateError.language.error = false;
                axios
                .post(save_url,this.form)
                .then(response => {
                    // console.log(response);
                    // this.languages = response.data.items;                    
                    if(whatNext=='more'){
                        this.form.name='';
                        this.form.language='';
                    }else{
                        window.location.href = this.base_url;
                    }
                }).catch(errors => {
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;           
                        // console.log(errorMessage);                                    
                        // console.log(typeof errorMessage);        
                        let fields = Object.keys(this.form);
                        fields.forEach(function(item,key){                            
                            if(typeof errorMessage[item] !='undefined'){
                                me.validateError[item].error = true;
                                me.validateError[item].message = errorMessage[item][0];
                            }                            
                        });

                        Object.keys(errorMessage).forEach(function(key){
                            // console.log(key);
                            let splited_key = key.split('.');

                            //ถ้า error ใน menu item
                            if(splited_key[0]=='menu_items')
                            {                                
                                let evalStr = 'me.menu_items'+me.travelAndSetNode(me.menu_items,0,splited_key,errorMessage[key][0])
                                // console.log(evalStr);
                                let evalStrForErrorStatus = evalStr+'.error = true';
                                let evalStrForErrorMessage = evalStr+'.message = "'+errorMessage[key][0]+'"';
                                // console.log(evalStrForErrorStatus);
                                // console.log(evalStrForErrorMessage);
                                eval(evalStrForErrorStatus);
                                eval(evalStrForErrorMessage);
                                // console.log(me.menu_items);
                                me.menu_item_data_entry_error = true;
                            }
                        })

                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ ติดต่อเจ้าหน้าที่'+ errors.response.data);
                    }                    
                });
                   
            },
            //ท่องไปตาม node ต่างๆของเมนู item เพื่อไป show error message
            travelAndSetNode(obj,keyIdx,splited_key,errorMessage){
                // console.log(obj); console.log(splited_key, splited_key[keyIdx], keyIdx);
                const leafNodes = ['url','label','category_id','disabled'];                
                if(leafNodes.includes(splited_key[keyIdx])){    
                    // console.log('oh Yes')
                    return splited_key[keyIdx];
                }else{
                    // console.log('oh No')
                    keyIdx++;                    
                    if(splited_key[keyIdx]=='children'){                        
                        // console.log('oh No 1')
                        return 'children'+this.travelAndSetNode(obj['children'],keyIdx,splited_key,errorMessage);
                    }else{                  
                        // console.log('oh No 2'); // console.log(splited_key[keyIdx]);       
                        if(leafNodes.includes(splited_key[keyIdx])){
                            return 'validateError.'+this.travelAndSetNode(obj[parseInt(splited_key[keyIdx])],keyIdx,splited_key,errorMessage);
                        }else{
                            return '['+splited_key[keyIdx]+'].'+this.travelAndSetNode(obj[parseInt(splited_key[keyIdx])],keyIdx,splited_key,errorMessage);
                        }                                                
                    }
                }
            },
            fetchLanguages(url){
                url = url || '/fetch/language';
                axios.get(url).then(response => {
                    this.languages = response.data.items;                    
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            fetchCategories(url){
                url = url || '/menu_category/list';
                axios.get(url).then(response => {
                    this.categories = response.data.menu_category;
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            }
        },
    }
</script>